const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 lg:py-32 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-20 space-y-4">
          <h2 className="font-['Inter'] font-bold text-5xl lg:text-7xl text-white leading-tight">
            Enhanced <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">Security</span><br />
            &amp; <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">Performance</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-10">
          <div className="lg:row-span-2 bg-white/5 border border-white/10 rounded-[28px] p-10 flex flex-col items-center text-center space-y-8 hover:bg-white/10 transition-colors duration-300">
            <div className="w-16 h-16 flex items-center justify-center">
              <i className="ri-lock-password-line text-6xl text-emerald-400"></i>
            </div>
            <h3 className="font-['Inter'] font-bold text-3xl text-white">Advanced Encryption</h3>
            <p className="text-white/70 text-base leading-relaxed max-w-sm">
              Our VPN application uses military-grade AES-256 encryption to protect your data and ensure your online activities remain private and secure from prying eyes.
            </p>
          </div>

          <div className="lg:col-span-2 bg-white/5 border border-white/10 rounded-[28px] p-10 flex items-center space-x-8 hover:bg-white/10 transition-colors duration-300">
            <div className="w-16 h-16 flex items-center justify-center flex-shrink-0">
              <i className="ri-rocket-line text-6xl text-cyan-400"></i>
            </div>
            <div className="space-y-3">
              <h3 className="font-['Inter'] font-bold text-3xl text-white">Lightning Fast</h3>
              <p className="text-white/70 text-base leading-relaxed">
                Experience blazing-fast connection speeds with our optimized servers located worldwide, ensuring smooth browsing and streaming without any lag.
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 bg-white/5 border border-white/10 rounded-[28px] p-10 flex items-center space-x-8 hover:bg-white/10 transition-colors duration-300">
            <div className="w-16 h-16 flex items-center justify-center flex-shrink-0">
              <i className="ri-smartphone-line text-6xl text-purple-400"></i>
            </div>
            <div className="space-y-3">
              <h3 className="font-['Inter'] font-bold text-3xl text-white">Device Optimization</h3>
              <p className="text-white/70 text-base leading-relaxed">
                Our Cleaner app intelligently analyzes your device to remove junk files, optimize storage, and boost performance for a smoother iOS experience.
              </p>
            </div>
          </div>

          <div className="lg:col-span-3 bg-white/5 border border-white/10 rounded-[28px] p-10 flex flex-col lg:flex-row items-center lg:items-start space-y-8 lg:space-y-0 lg:space-x-12 hover:bg-white/10 transition-colors duration-300">
            <div className="w-16 h-16 flex items-center justify-center flex-shrink-0">
              <i className="ri-user-heart-line text-6xl text-pink-400"></i>
            </div>
            <div className="space-y-4 text-center lg:text-left flex-1">
              <h3 className="font-['Inter'] font-bold text-3xl text-white">User-Centric Design</h3>
              <p className="text-white/70 text-base leading-relaxed max-w-3xl">
                Every feature in our applications is designed with the user in mind. We focus on creating intuitive interfaces that make complex security and optimization tasks simple and accessible for everyone, regardless of technical expertise.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
